export default __webpack_public_path__ + "static/media/werekitty_head.1feb9ef1.png";